import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Divider, Typography } from 'fronton-react';
import { ArrowRightIcon, IdentificationBadgeIcon } from '@fronton/icons-react';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { getTitle } from 'features/page-model/ducks/get-model';
import { analyticsUtils } from 'utils';
import { cx } from 'linaria';
import { silentLink } from '../store-contacts';
import {
  iconAlign,
  idIconAlign,
  storeVacanciesContainer,
  storeVacanciesText,
  divider,
  WorkText,
  vacanciesLink,
} from './styles';
import { useHasServicesLinks } from 'common/hooks/use-has-services-links';

export const StoreVacancies: FC = () => {
  const { t } = useTranslation();
  const { mobile, smMobile } = useBreakpoints() ?? {};
  const title = useSelector(getTitle);
  const jobInCompany = t('jobInCompany', { companyBrand: t('legalName') });

  const handleClick = useCallback(() => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'shopPage', // блок, в котором расположен элемент
      elementName: title, // название блока
      elementText: jobInCompany, // текст кнопки (Как добраться транспортом, Товары в магазине, План магазина, Фото магазина)
    });
  }, [title, jobInCompany]);

  const hasLink = useHasServicesLinks();

  return (
    <div className={storeVacanciesContainer}>
      <Divider className={divider} />
      <a
        href={hasLink ? 'https://rabota.lemanapro.ru/' : 'https://almaty.hh.kz/employer/2943789'}
        target="_blank"
        rel="noreferrer"
        className={cx(silentLink, vacanciesLink)}
        data-qa="store-vacancies"
        onClick={handleClick}
      >
        <div className={storeVacanciesText}>
          <WorkText>
            <IdentificationBadgeIcon color="text-primary" type="fill" size="l" className={idIconAlign} />
            <Typography variant="m" size="body_long">
              {jobInCompany}
            </Typography>
          </WorkText>
          <WorkText data-qa="vacancy-look">
            {!mobile && !smMobile && (
              <Typography variant="m" size="body_long">
                {t('seeJobs')}
              </Typography>
            )}
            <ArrowRightIcon color="text-primary" size="l" className={iconAlign} />
          </WorkText>
        </div>
      </a>
      <Divider className={divider} />
    </div>
  );
};
